import "./NotFound.less";
import * as React from "react";

export const NotFound: React.FunctionComponent = () => (
    <div className={"NotFound"}>
        <h3>{"global.pageNotFoundText".localize()}</h3>
    </div>
);
